// extracted by mini-css-extract-plugin
export default {"wrapper":"GetAge_wrapper__FWCuV","active":"GetAge_active__Scfut","AgeSelectionRadioButton":"GetAge_AgeSelectionRadioButton__630hG"};